var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuyerDashboardWelcomeImage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 225,
    height: 178,
    viewBox: "0 0 225 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "undraw_web_search_re_efla 1",
    clipPath: "url(#clip0_2022_17540)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M204.317 0.744629H0.594727V131.217H204.317V0.744629Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M198.478 17.1089H6.40723V123.498H198.478V17.1089Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M204.223 0.628906H0.500977V9.28376H204.223V0.628906Z",
    fill: "#7636D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M6.93321 6.65744C7.81914 6.65744 8.53732 5.93925 8.53732 5.05333C8.53732 4.1674 7.81914 3.44922 6.93321 3.44922C6.04729 3.44922 5.3291 4.1674 5.3291 5.05333C5.3291 5.93925 6.04729 6.65744 6.93321 6.65744Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M13.027 6.65744C13.9129 6.65744 14.6311 5.93925 14.6311 5.05333C14.6311 4.1674 13.9129 3.44922 13.027 3.44922C12.141 3.44922 11.4229 4.1674 11.4229 5.05333C11.4229 5.93925 12.141 6.65744 13.027 6.65744Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M19.1207 6.65744C20.0066 6.65744 20.7248 5.93925 20.7248 5.05333C20.7248 4.1674 20.0066 3.44922 19.1207 3.44922C18.2348 3.44922 17.5166 4.1674 17.5166 5.05333C17.5166 5.93925 18.2348 6.65744 19.1207 6.65744Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M73.2448 28.1475H23.8916V112.459H73.2448V28.1475Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M122.863 28.1475H81.7354V51.3552H122.863V28.1475Z",
    fill: "#7636D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M122.863 57.8184H81.7354V82.7887H122.863V57.8184Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M122.863 89.252H81.7354V112.46H122.863V89.252Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M181.042 28.1475H131.688V64.8901H181.042V28.1475Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M181.042 75.7168H131.688V112.459H181.042V75.7168Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M162.032 67.5298V59.6196C162.032 56.8084 163.149 54.1124 165.137 52.1246C167.125 50.1368 169.821 49.02 172.632 49.02C175.443 49.02 178.139 50.1368 180.127 52.1246C182.115 54.1124 183.231 56.8084 183.231 59.6196V67.5298C183.231 67.9073 183.081 68.2692 182.814 68.5361C182.547 68.803 182.185 68.9532 181.808 68.9536H163.456C163.079 68.9532 162.717 68.803 162.45 68.5361C162.183 68.2692 162.033 67.9073 162.032 67.5298Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M188.306 170.471L184.568 171.505L178.798 157.578L184.316 156.051L188.306 170.471Z",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M181.619 171.177L188.829 169.181L190.085 173.721L178.335 176.973C178.17 176.377 178.125 175.754 178.2 175.14C178.276 174.526 178.472 173.933 178.777 173.395C179.082 172.857 179.489 172.384 179.977 172.003C180.465 171.623 181.023 171.342 181.619 171.177Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M149.335 173.346H145.456L143.61 158.384H149.336L149.335 173.346Z",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M142.68 172.238H150.161V176.949H137.97C137.97 176.33 138.092 175.718 138.328 175.146C138.565 174.575 138.912 174.055 139.349 173.618C139.787 173.181 140.306 172.834 140.877 172.597C141.449 172.36 142.061 172.238 142.68 172.238Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M144.626 89.7282C144.903 90.1019 145.259 90.4104 145.668 90.6319C146.077 90.8535 146.529 90.9826 146.993 91.0103C147.458 91.038 147.923 90.9635 148.355 90.7921C148.787 90.6207 149.177 90.3567 149.496 90.0184L159.808 94.6563L158.87 88.8561L149.222 85.3411C148.618 84.8423 147.852 84.5824 147.07 84.6105C146.287 84.6385 145.542 84.9527 144.975 85.4935C144.409 86.0342 144.061 86.764 143.996 87.5445C143.932 88.325 144.156 89.1019 144.626 89.7282Z",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M166.072 124.608C162.832 124.608 159.479 124.126 156.66 122.691C155.163 121.944 153.837 120.896 152.764 119.613C151.691 118.33 150.894 116.839 150.424 115.234C148.955 110.583 150.807 106.014 152.598 101.596C153.707 98.8575 154.756 96.2714 155.028 93.7222L155.123 92.8172C155.546 88.7521 155.912 85.2414 157.938 83.9246C158.988 83.242 160.399 83.2031 162.254 83.8053L179.67 89.4631L179.03 122.524L178.924 122.56C178.833 122.59 172.693 124.608 166.072 124.608Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M161.963 73.5128C161.963 73.5128 170.506 70.9815 177.151 71.9308C177.151 71.9308 173.354 92.8136 174.619 99.7745C175.885 106.735 152.629 102.464 157.375 95.8194L158.957 87.9093C158.957 87.9093 155.793 84.7452 158.641 80.9483L161.963 73.5128Z",
    fill: "#7636D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M157.749 123.982L147.22 122.007L150.896 93.7186C151.143 92.9288 156.837 75.0053 159.423 74.0356C161.301 73.3743 163.221 72.8408 165.171 72.4387L165.546 72.3638L163.435 75.5306L155.029 95.6712L157.749 123.982Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M152.245 169.88L138.642 167.613L146.276 136.439L157.636 93.8076L157.748 94.5646C157.757 94.621 158.818 100.19 174.565 97.7191L174.704 97.6975L174.742 97.8324L193.774 165.081L178.274 167.664L164.136 118.6L152.245 169.88Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M171.126 129.276L171.134 129.036C171.144 128.771 172.08 102.34 171.767 91.7107C171.454 81.045 174.907 71.8085 174.942 71.7164L174.97 71.6423L175.046 71.6203C179.514 70.344 183.389 74.1533 183.428 74.1919L183.482 74.2463L182.21 84.7435L187.657 122.915L171.126 129.276Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M170.46 68.7696C174.752 68.7696 178.231 65.2903 178.231 60.9983C178.231 56.7064 174.752 53.2271 170.46 53.2271C166.168 53.2271 162.688 56.7064 162.688 60.9983C162.688 65.2903 166.168 68.7696 170.46 68.7696Z",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M159.532 60.2524C159.535 58.0294 160.419 55.8982 161.991 54.3263C163.563 52.7544 165.694 51.8702 167.917 51.8677H169.499C171.722 51.8702 173.853 52.7544 175.425 54.3263C176.997 55.8982 177.881 58.0294 177.884 60.2524V60.4106H174.54L173.4 57.2175L173.172 60.4106H171.444L170.869 58.7996L170.754 60.4106H159.532V60.2524Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M169.697 69.843C169.54 69.6304 169.446 69.3779 169.427 69.1144C169.407 68.8509 169.462 68.5872 169.586 68.3537C171.262 65.1649 173.61 59.2728 170.494 55.639L170.27 55.3779H179.315V68.9581L171.098 70.4078C171.015 70.4225 170.931 70.43 170.846 70.4301C170.622 70.4301 170.401 70.3768 170.201 70.2748C170.001 70.1727 169.829 70.0248 169.697 69.843Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M133.257 13.7744C126.928 8.43358 119.183 5.04756 110.964 4.02838C102.745 3.0092 94.4074 4.40081 86.9652 8.03387C79.523 11.6669 73.2972 17.3848 69.0454 24.4917C64.7936 31.5985 62.6991 39.788 63.0168 48.0636C63.3345 56.3391 66.0507 64.3439 70.8349 71.1039C75.619 77.8639 82.2649 83.0876 89.9637 86.1394C97.6626 89.1912 106.082 89.9395 114.199 88.2932C122.315 86.6469 129.778 82.6771 135.679 76.8667L188.082 121.084C188.879 121.758 189.912 122.088 190.952 122C191.993 121.913 192.956 121.416 193.63 120.619C194.304 119.822 194.634 118.789 194.547 117.749C194.46 116.708 193.963 115.745 193.165 115.071L193.16 115.066L140.757 70.8492C146.844 62.1123 149.45 51.4169 148.063 40.8591C146.675 30.3013 141.395 20.6421 133.257 13.7744ZM129.879 66.5914C125.797 71.4295 120.371 74.9484 114.289 76.7031C108.207 78.4578 101.741 78.3695 95.7085 76.4494C89.6763 74.5292 84.3491 70.8634 80.4003 65.9156C76.4516 60.9678 74.0587 54.9601 73.5243 48.6523C72.9899 42.3446 74.338 36.02 77.3981 30.4784C80.4582 24.9368 85.0928 20.427 90.7159 17.5194C96.339 14.6118 102.698 13.437 108.989 14.1434C115.28 14.8499 121.22 17.4059 126.058 21.4883C129.27 24.1989 131.917 27.5157 133.848 31.2493C135.779 34.983 136.955 39.0603 137.31 43.2485C137.664 47.4367 137.191 51.6538 135.916 55.6589C134.641 59.6641 132.59 63.379 129.879 66.5914Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    opacity: 0.3,
    d: "M84.7676 70.4125C78.6274 65.231 74.6604 57.9298 73.6542 49.9587C72.648 41.9876 74.6763 33.9296 79.3363 27.3848C78.7243 28.0011 78.1327 28.6465 77.5615 29.3211C74.8508 32.5335 72.7995 36.2484 71.5246 40.2536C70.2496 44.2587 69.776 48.4758 70.1309 52.664C70.4857 56.8523 71.662 60.9296 73.5925 64.6632C75.5231 68.3968 78.1701 71.7136 81.3825 74.4242C84.595 77.1348 88.3098 79.1861 92.315 80.4611C96.3202 81.736 100.537 82.2096 104.725 81.8548C108.914 81.5 112.991 80.3237 116.725 78.3931C120.458 76.4626 123.775 73.8155 126.486 70.6031C127.056 69.9276 127.592 69.2359 128.096 68.5278C122.428 74.2224 114.826 77.5774 106.8 77.9266C98.7728 78.2757 90.9083 75.5935 84.7676 70.4125Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M172.929 103.314C173.381 103.424 173.852 103.434 174.308 103.343C174.764 103.252 175.194 103.062 175.569 102.787C175.944 102.511 176.254 102.157 176.477 101.749C176.7 101.341 176.831 100.889 176.86 100.424L187.755 97.4003L183.326 93.5391L173.659 97.0027C172.876 97.005 172.121 97.2945 171.537 97.8163C170.953 98.3382 170.581 99.0561 170.491 99.834C170.401 100.612 170.599 101.396 171.049 102.037C171.498 102.679 172.167 103.133 172.929 103.314Z",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M177.461 101.713L176.798 95.4149L185.898 90.3938L179.965 83.2113L180.933 75.1431L183.344 74.1099L183.419 74.2063C184.556 75.6681 194.527 88.5334 194.527 90.1238C194.527 91.7572 192.619 96.5541 190.01 97.859C187.492 99.1177 178.04 101.564 177.639 101.668L177.461 101.713Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M224.681 177.371H104.13C104.046 177.371 103.965 177.338 103.906 177.278C103.847 177.219 103.813 177.139 103.813 177.055C103.813 176.971 103.847 176.89 103.906 176.831C103.965 176.772 104.046 176.738 104.13 176.738H224.681C224.765 176.738 224.845 176.772 224.904 176.831C224.964 176.89 224.997 176.971 224.997 177.055C224.997 177.139 224.964 177.219 224.904 177.278C224.845 177.338 224.765 177.371 224.681 177.371Z",
    fill: "#CCCCCC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2022_17540"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 224.501,
    height: 176.743,
    fill: "white",
    transform: "translate(0.499023 0.628906)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuyerDashboardWelcomeImage);
export default __webpack_public_path__ + "static/media/buyerDashboardWelcomeImage.388963db432ef2fa84540eb51d861fd5.svg";
export { ForwardRef as ReactComponent };